module.exports = __webpack_public_path__ + "static/media/howls-back.cf83e115.jpg";